import {
  abuseReportListResponseSchema,
  abuseReportSchema,
  submitAbuseReportRequestSchema,
  type SubmitAbuseReportRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createAbuseResource(ctx: RequestContext) {
  return {
    submit(body: SubmitAbuseReportRequest) {
      const payload = submitAbuseReportRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/abuse-reports",
        body: payload,
        dataSchema: abuseReportSchema,
        auth: true,
      });
    },

    listMine(cursor?: string, limit?: number) {
      const qs = new URLSearchParams();
      if (cursor) qs.set("cursor", cursor);
      if (limit) qs.set("limit", String(limit));
      const query = qs.toString();
      return requestJson(ctx, {
        method: "GET",
        path: `/me/abuse-reports${query ? `?${query}` : ""}`,
        dataSchema: abuseReportListResponseSchema,
        auth: true,
      });
    },
  };
}
